import {
  editClientToDo,
  createTemplateToDo,
  createTemplateToDoForClient,
  createToDoForClient,
  deleteToDoForClient,
  getClientToDos,
  getToDoTemplates,
  getToDoTemplateById,
  editTemplateToDo,
  deleteToDoTemplate,
} from './asyncThunks';

export const getClientToDosBuilder = builder => {
  builder
    .addCase(getClientToDos.pending, state => {
      state.getClientToDosPending = true;
    })
    .addCase(getClientToDos.fulfilled, (state, action) => {
      state.clientToDos.data = action.payload.data;
      state.clientToDos.total = action.payload.total;
      state.getClientToDosPending = false;
    })
    .addCase(getClientToDos.rejected, (state, action) => {
      state.getClientToDosPending = false;
    });
};

export const createTodDoForClientBuilder = builder => {
  builder.addCase(createToDoForClient.pending, state => {
    state.createToDoForClientPending = true;
  });
  builder.addCase(createToDoForClient.fulfilled, (state, { payload }) => {
    const { data } = payload;

    state.clientToDos.data = [data, ...state.clientToDos.data];
    state.createToDoForClientPending = false;
  });
  builder.addCase(createToDoForClient.rejected, state => {
    state.createToDoForClientPending = false;
  });
};

export const deleteToDoForClientBuilder = builder => {
  builder.addCase(deleteToDoForClient.pending, state => {
    state.deleteToDoForClientPending = true;
  });
  builder.addCase(deleteToDoForClient.fulfilled, (state, { payload }) => {
    const { id } = payload;

    state.clientToDos.data = state.clientToDos.data.filter(toDo => toDo.id !== id);
    state.deleteToDoForClientPending = false;
  });
  builder.addCase(deleteToDoForClient.rejected, state => {
    state.deleteToDoForClientPending = false;
  });
};

export const createTodDoTemplateBuilder = builder => {
  builder.addCase(createTemplateToDo.pending, state => {
    state.createToDoTemplatePending = true;
  });
  builder.addCase(createTemplateToDo.fulfilled, (state, { payload }) => {
    const { data } = payload;
    if (state.toDoTemplates.maxReached) {
      state.toDoTemplates.data = [...state.toDoTemplates.data, data];
    }

    state.createToDoTemplatePending = false;
  });
  builder.addCase(createTemplateToDo.rejected, state => {
    state.createToDoTemplatePending = false;
  });
};

export const getToDoTemplatesBuilder = builder => {
  builder.addCase(getToDoTemplates.pending, state => {
    state.getToDoTemplatesPending = true;
  });
  builder.addCase(getToDoTemplates.fulfilled, (state, { payload }) => {
    const { data, maxReached, total, page, perPage } = payload;

    state.toDoTemplates.data = data;
    state.toDoTemplates.page = page;
    state.toDoTemplates.perPage = perPage;
    state.toDoTemplates.maxReached = maxReached;
    state.toDoTemplates.total = total;
    state.getToDoTemplatesPending = false;
  });
  builder.addCase(getToDoTemplates.rejected, state => {
    state.getToDoTemplatesPending = false;
  });
};

export const createTodDoTemplateForClientBuilder = builder => {
  builder.addCase(createTemplateToDoForClient.pending, state => {
    state.createToDoTemplateForClientPending = true;
  });
  builder.addCase(createTemplateToDoForClient.fulfilled, (state, { payload }) => {
    const { data } = payload;

    state.clientToDos.data = [...data, ...state.clientToDos.data];
    state.createToDoTemplateForClientPending = false;
  });
  builder.addCase(createTemplateToDoForClient.rejected, state => {
    state.createToDoTemplateForClientPending = false;
  });
};

export const editClientToDoBuilder = builder => {
  builder.addCase(editClientToDo.pending, state => {
    state.editClientToDoPending = true;
  });
  builder.addCase(editClientToDo.fulfilled, (state, { payload }) => {
    const { data, id } = payload;

    state.clientToDos.data = state.clientToDos.data.map(toDo => {
      if (toDo.id === id) {
        toDo.title = data.title;
        toDo.description = data.description;
        toDo.date = data.date;
      }
      return toDo;
    });

    state.editClientToDoPending = false;
  });
  builder.addCase(editClientToDo.rejected, state => {
    state.editClientToDoPending = false;
  });
};

export const getToDoTemplateByIdBuilder = builder => {
  builder.addCase(getToDoTemplateById.pending, state => {
    state.getToDoTemplateByIdPending = true;
  });
  builder.addCase(getToDoTemplateById.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.selectedTemplate.data = data.template;
    state.selectedTemplate.toDos = data.templateToDos;

    state.getToDoTemplateByIdPending = false;
  });
  builder.addCase(getToDoTemplateById.rejected, state => {
    state.getToDoTemplateByIdPending = false;
  });
};

export const editToDoTemplateBuilder = builder => {
  builder.addCase(editTemplateToDo.pending, state => {
    state.editTemplateToDoPending = true;
  });
  builder.addCase(editTemplateToDo.fulfilled, (state, { payload }) => {
    const { data } = payload;

    state.toDoTemplates.data = state.toDoTemplates.data.map(template => {
      if (template.id === data.id) {
        template.title = data.title;
        template.description = data.description;
      }
      return template;
    });

    state.editTemplateToDoPending = false;
  });
  builder.addCase(editTemplateToDo.rejected, state => {
    state.editTemplateToDoPending = false;
  });
};

export const deleteToDoTemplateBuilder = builder => {
  builder.addCase(deleteToDoTemplate.pending, state => {
    state.deleteToDoTemplatePending = true;
  });
  builder.addCase(deleteToDoTemplate.fulfilled, (state, { payload }) => {
    const { id } = payload;

    state.toDoTemplates.data = state.toDoTemplates.data.filter(template => template.id !== id);
    state.deleteToDoTemplatePending = false;
  });
  builder.addCase(deleteToDoTemplate.rejected, state => {
    state.deleteToDoTemplatePending = false;
  });
};
